<template>
  <div id="legal">
    Le présent site internet https://piquage.com
    est la propriété de la Sarl Atelier-Sud, dont le siège social est
    situé au: 1 rue du Pont - 34150 Gignac - France, au capital social
    de 9 146,94 €, immatriculé sous le numéro de siren 412212177. Le directeur
    de la publication est M. Thierry Reynaud, ayant la qualité de Responsable de
    la communication informatique de la société Atelier-Sud.
    <br />
    <br />Informations
    relatives à l’hébergeur :
    <br />Société Ionos gmbh dont le siège social français
    est situé 1&1 Internet SARL - 7, place de la Gare - BP 70109 - 57200
    Sarreguemines Cedex
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
#legal {
  margin: 10px;
}
* {
  color: #000;
}
</style>